import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from "./Container.module.css";
const containerPropTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  fluid: PropTypes.bool
};
export const Container = ({
  children,
  className,
  fluid
}) => {
  const containerClasses = cx(styles.container, className, {
    [styles.fluid]: fluid
  });
  return React.createElement("div", {
    className: containerClasses
  }, children);
};
Container.propTypes = containerPropTypes;
Container.__docgenInfo = {
  componentName: "Container",
  packageName: "@jutro/components",
  description: "Container element which wraps some content.",
  displayName: "Container",
  methods: [],
  actualName: "Container",
  props: {
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "Additional class names for component."
    },
    children: {
      type: {
        name: "node"
      },
      required: false,
      description: "The container's content."
    },
    fluid: {
      type: {
        name: "bool"
      },
      required: false,
      description: "Span the entire width."
    }
  }
};